import {
  EducationMaterialControllerApi,
  PatientEducationMaterial,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type EducationMaterialShareWithParam = {
  patientEducationMaterial: PatientEducationMaterial;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useEducationMaterialShareWith = () =>
  useMutationWithLoading(async (params: EducationMaterialShareWithParam) =>
    new EducationMaterialControllerApi(
      getConfigObject()
    ).shareEducationMaterialWithPatient(
      params.patientEducationMaterial,
      params.xTENANTID
    )
  );
